import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import "./DifferenceTools.css";
import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { ReactComponent as CheckGreen } from "../../Icons/checkGreen.svg";
import { ReactComponent as CheckRed } from "../../Icons/CheckRed.svg";
import { ReactComponent as CheckBlue } from "../../Icons/CheckBlue.svg";

function CSVMultiDiffViewer() {
    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState(0);

    const {
        comparisons = {},
    } = location.state || {};

    const results = Object.entries(comparisons || {});
    const activeComparison = results[activeIndex]?.[1] || {};

    const getTypeClass = (type) => {
        switch (type) {
            case "CELL_DIFF":
                return "csv-diff-cell";
            case "MISSING_ROW":
                return "csv-diff-missing";
            case "EXTRA_ROW":
                return "csv-diff-extra";
            default:
                return "";
        }
    };

    const getTypeLabel = (type) => {
        switch (type) {
            case "CELL_DIFF":
                return "CELL-DIFF";
            case "MISSING_ROW":
                return "MISSING-ROW";
            case "EXTRA_ROW":
                return "EXTRA-ROW";
            default:
                return type;
        }
    };

    return (
        <Col>

            {/* HEADER */}
            <ToolHeader title="Comparison Results" description="Compare a base CSV with multiple CSV inputs" showFavourite={false} />

            {/* SUMMARY */}
            <Row className="ActionButtons diff-action-buttons">

                {results.map(([key, item], index) => (
                    <Col
                        key={key}
                        onClick={() => setActiveIndex(index)}
                        className={`ActionButton diff-action-button ${activeIndex === index ? "active" : ""
                            }`}
                        style={{
                            cursor: "pointer",
                            backgroundColor:
                                activeIndex === index
                                    ? "#4F3CFA1A"
                                    : ""
                        }}
                    >
                        <span style={{ color: "var(--text-color)" }}>
                            CSV {index + 2}
                        </span>

                        <span
                            style={{
                                color: "#21C55E",
                                padding: "4px 8px"
                            }}
                        >
                            {item.rowDiffCount || 0} rows
                        </span>

                        <span
                            style={{
                                color: "#EF4444",
                                padding: "4px 8px"
                            }}
                        >
                            {item.columnDiffCount || 0} attrs
                        </span>

                        <span
                            style={{
                                color: "#3B82F6",
                                padding: "4px 8px"
                            }}
                        >
                            {item.cellDiffCount || 0} cells
                        </span>
                    </Col>
                ))}
            </Row>

            {/* LEGEND */}
            <Row className="Introduction-Header align-items-center">

                <Col md={6} className="diff-legend">

                    <span style={{ color: "#21C55E" }}>
                        <CheckGreen /> Extra rows
                    </span>

                    <span style={{ color: "#EF4444" }}>
                        <CheckRed /> Missing rows
                    </span>

                    <span style={{ color: "#3B82F6" }}>
                        <CheckBlue /> Cell differences
                    </span>

                </Col>

                <Col
                    md={6}
                    className="DiffoutputToggleWraper d-flex justify-content-end"
                >
                    {results.map((_, idx) => (
                        <div
                            key={idx}
                            className={`DiffoutputToggle ${activeIndex === idx ? "active" : ""
                                }`}
                            style={{
                                backgroundColor:
                                    activeIndex === idx
                                        ? "#5B4CFF"
                                        : "",
                                cursor: "pointer"
                            }}
                            onClick={() => setActiveIndex(idx)}
                        >
                            CSV {idx + 2}
                        </div>
                    ))}
                </Col>
            </Row>

            {/* DIFFERENCE COUNT */}
            <div className="csv-total-badge">
                {activeComparison.differences?.length || 0} total
            </div>

            {/* DIFFERENCE CARDS */}
            <div className="csv-diff-wrapper">

                {activeComparison?.differences?.map((diff, idx) => (

                    <div
                        key={idx}
                        className={`csv-diff-card ${getTypeClass(diff.type)}`}
                    >

                        {/* HEADER */}
                        <div className="csv-diff-header">


                                {/* TOP PATH */}
                                <div className="csv-diff-path">

                                    {diff.type === "CELL_DIFF" && (
                                        <>
                                            key={diff.rowIndex} • col={diff.columnName}
                                        </>
                                    )}

                                    {diff.type === "MISSING_ROW" && (
                                        <>
                                            key={diff.rowIndex}
                                        </>
                                    )}

                                    {diff.type === "EXTRA_ROW" && (
                                        <>
                                            key={diff.rowIndex}
                                        </>
                                    )}

                                </div>

                            <div className="csv-diff-type">
                                {getTypeLabel(diff.type)}
                            </div>

                        </div>

                        {/* SUB */}
                        <div className="csv-diff-subtitle">

                            {diff.type === "CELL_DIFF" && (
                                <>
                                    Cell content differs
                                </>
                            )}

                            {diff.type === "MISSING_ROW" && (
                                <>
                                    Row missing in compare
                                </>
                            )}

                            {diff.type === "EXTRA_ROW" && (
                                <>
                                    Extra row added in compare
                                </>
                            )}

                        </div>

                        {/* ROWS */}
                        <div className="csv-diff-content">

                            {/* BASE */}
                            <div className="csv-diff-box-wrapper">

                                <div className="csv-diff-box-title">
                                    BASE
                                </div>

                                <div className="csv-diff-box">
                                    {diff.baseValue || "-"}
                                </div>

                            </div>

                            {/* COMPARE */}
                            <div className="csv-diff-box-wrapper">

                                <div className="csv-diff-box-title">
                                    COMPARE
                                </div>

                                <div className="csv-diff-box">
                                    {diff.compareValue || "-"}
                                </div>

                            </div>

                        </div>

                    </div>

                ))}

            </div>

            {/* INACTIVE ITEMS */}


        </Col>
    );
}

export default CSVMultiDiffViewer;
